import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./App.css";
import App from "./App";
import ScrollToTop from "./ScrollToTop";
import {
  ParallaxProvider
} from "react-scroll-parallax";
import "react-responsive-modal/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ParallaxProvider>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </ParallaxProvider>
  </BrowserRouter>
);